import AccessTime from "@mui/icons-material/AccessTime";

import { LabelValue } from "../../components/LabelValue";
import { useProductTranslation } from "../../hooks/useProductTranslation";

export type ProductStartTimeProps = {
    startTime: string;
};

export function ProductStartTimeMetaData({ startTime }: ProductStartTimeProps) {
    const [t] = useProductTranslation();
    const label = t("label.startTime");
    return (
        <LabelValue label={label} Icon={AccessTime}>
            {startTime}
        </LabelValue>
    );
}
